import React, { Component } from 'react';
import { Link } from 'react-router';
import { accountRoute } from '../../../routes';

import {
	ROLE_JUDGE_FOTD,
	ROLE_JUDGE_FOTM,
	ROLE_JUDGE_FOTY,
	ROLE_JUDGE_TCEA,
} from '../../../utils/authorization';

export default class JuryNav extends Component {
	render() {
		return (
			<ol className='account-jury__subhead__navigation'>
				{this.props.users.canHas([ROLE_JUDGE_FOTD]) && (
					<li><Link to={accountRoute('/jury/fotd')} activeClassName='active'>FOTD</Link></li>
				)}
				{this.props.users.canHas([ROLE_JUDGE_FOTM]) && (
					<li><Link to={accountRoute('/jury/fotm')} activeClassName='active'>FOTM</Link></li>
				)}
				{this.props.users.canHas([ROLE_JUDGE_FOTY]) && (
					<li><Link to={accountRoute('/jury/foty')} activeClassName='active'>FOTY</Link></li>
				)}
				{this.props.users.canHas([ROLE_JUDGE_TCEA]) && (
					<li><Link to={accountRoute('/jury/tcea')} activeClassName='active'>TCEA</Link></li>
				)}
			</ol>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/juryNav.js
 **/